<div class="d-inline-flex" *ngIf="orderDetail">
	<button
		type="button"
		class="btn btn-sm d-inline-flex align-items-center justify-content-center gap-2 border bg-white text-nowrap"
		(click)="openDialog()"
	>
		<i class="fa-regular fa-file-arrow-up"></i>
		<span>UCDP/EAD</span>
	</button>
</div>
